import Vue from 'vue'
import Vuex from 'vuex'
import { login } from '@/api/auth'
import { getMe } from '@/api/user'

Vue.use(Vuex)

const TOKEN_KEY = 'detonation_admin_token_v2'

export default new Vuex.Store({
  state: {
    token: localStorage.getItem(TOKEN_KEY) || '',
    name: '',
    username: '',
    role: '',
    roleLabel: '',
    roles: [],
    permissions: {}
  },
  getters: {
    token: state => state.token,
    name: state => state.name,
    username: state => state.username,
    role: state => state.role,
    roleLabel: state => state.roleLabel,
    roles: state => state.roles,
    permissions: state => state.permissions,
    canControl: state => !!state.permissions.can_control,
    canManageUsers: state => !!state.permissions.can_manage_users,
    canManagePermissions: state => !!state.permissions.can_manage_permissions,
    canManageSystem: state => !!state.permissions.can_manage_system,
    hasAction: state => key => ((state.permissions.actions || []).includes(key)),
    hasView: state => key => ((state.permissions.views || []).includes(key))
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      if (token) localStorage.setItem(TOKEN_KEY, token)
      else localStorage.removeItem(TOKEN_KEY)
    },
    SET_PROFILE(state, profile) {
      state.name = profile.name || profile.real_name || profile.username || ''
      state.username = profile.username || ''
      state.role = profile.role || ''
      state.roleLabel = profile.role_label || (profile.roles && profile.roles[0]) || profile.role || ''
      state.roles = profile.roles || (state.roleLabel ? [state.roleLabel] : [])
      state.permissions = profile.permissions || {}
    }
  },
  actions: {
    async login({ commit }, payload) {
      const data = await login(payload)
      commit('SET_TOKEN', data.access_token)
      commit('SET_PROFILE', data)
      return data
    },
    async loadProfile({ commit }) {
      const data = await getMe()
      commit('SET_PROFILE', data)
      return data
    },
    logout({ commit }) {
      commit('SET_TOKEN', '')
      commit('SET_PROFILE', {})
    }
  }
})
